import type { NodeDefinition } from "~/nodes/types";

export const animateNode: NodeDefinition = {
  type: "animate",
  label: "Animate",
  category: "Input",
  inputs: [
    {
      key: "min",
      label: "Min",
      socket: "number",
      control: { kind: "number", key: "min", label: "min" },
    },
    {
      key: "max",
      label: "Max",
      socket: "number",
      control: { kind: "number", key: "max", label: "max" },
    },
    {
      key: "delta",
      label: "Delta T",
      socket: "number",
      control: { kind: "number", key: "delta", label: "delta" },
    },
  ],
  outputs: [{ key: "num", label: "Number", socket: "number" }],
  controls: [
    { kind: "preview", key: "preview", label: "value" },
    { kind: "toggle", key: "mirror", label: "Mirror" },
  ],
  defaults: { min: 1, max: 1, delta: 1, mirror: false },

  compute(ctx) {
    const min = ctx.number("min", 1);
    const max = ctx.number("max", 1);
    const period = ctx.number("delta", 1);
    const t = ctx.time;

    // Mirror gives a triangle wave (ramps up then back down); otherwise a sawtooth.
    const phase =
      ctx.data["mirror"] === true
        ? 0.5 +
          (1 / Math.PI) *
            Math.asin(Math.sin((2 / period) * Math.PI * (0.5 * t - period / 4)))
        : (t % period) / period;

    const value = min + phase * (max - min);

    ctx.preview("preview", value);
    return { num: Number.isFinite(value) ? value : min };
  },
};
